import styled from 'styled-components';
import { devices } from '../../Styles';

export const SearchBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  gap: 8px;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  background-color: ${({ theme }) => theme.migrateColors('background.primary', 'white')};

  .searchInputContainer {
    display: flex;
    width: 100%;
    max-height: 36px;
    border: ${({ theme }) => `1px solid ${theme.migrateColors('border.inputDefault', 'gray50')}`};
    padding: ${({ theme }) => theme.spacing[8]};
    border-radius: ${({ theme }) => theme.borderRadius.sm};
    transition: 200ms ease-in-out;
  }

  .searchInput {
    margin-left: 8px;
    width: 100%;
    border: 0;
    outline: none;
    color: ${({ theme }) => theme.migrateColors('text.subtle', 'gray80')};
    font-family: ${({ theme }) => theme.fontFamily};
    font-size: 14px;

    &::placeholder {
      font-family: ${({ theme }) => theme.fontFamily};
      color: ${({ theme }) => theme.migrateColors('text.subtlest', 'gray50')};
      font-size: 14px;
    }

    @media ${devices['no-mobile']} {
      grid-template-columns: 0.05fr 2fr 0.1fr;
    }
  }

  .searchResultText {
    color: ${({ theme }) => theme.migrateColors('text.default', 'gray')};
    opacity: 50%;
    font-weight: 400;
  }
`;
